
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const goalWeightlossReason = useStore((state) => state.goalWeightlossReason);
  const setGoalWeightlossReason = useStore((state) => state.setGoalWeightlossReason);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goalWeightlossReason.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={goalWeightlossReason}
          onChange={(value) => {
            setGoalWeightlossReason(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'goal-weightloss-reason',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Feel more confident'}>
            <span>💃</span> {t('onboarding.goalWeightlossReason.options.feelConfident')}
          </Option>
          <Option value={"Improve overall health"}>
            <span>❤️</span> {t('onboarding.goalWeightlossReason.options.improveHealth')}
          </Option>
           <Option value={"Get in better shape"}>
            <span>🏃</span> {t('onboarding.goalWeightlossReason.options.betterShape')}
          </Option>
          <Option value={'Prepare for a special event'}>
            <span>🎉</span> {t('onboarding.goalWeightlossReason.options.prepareForEvent')}
          </Option>
          <Option value={'Other'}>
            <span>✨</span> {t('onboarding.goalWeightlossReason.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
